const getBackgroundColors = () => {
  return {
    bgContent: {
      default: 'whiteAlpha.900',
      _dark: 'gray.800',
    },
    bgContentHover: {
      default: 'blackAlpha.50',
      _dark: 'gray.900',
    },
    bgContentPrimary: {
      default: 'primary.500',
      _dark: 'primary.600',
    },
    bgContentPrimaryHover: {
      default: 'primary.600',
      _dark: 'primary.700',
    },
    bgContainer: {
      default: 'gray.100',
      _dark: 'gray.700',
    },
    bgContainerHover: {
      default: 'gray.200',
      _dark: 'gray.800',
    },
  }
}

export default getBackgroundColors()
